export enum PropertyCardInstallments {
  IN_CASH = 'À_VISTA_COM_DESCONTO_POR_R$_3420',
  ENTRY_FOUR_INSTALLMENTS = '4_PARCELAS_DE_R$_9000',
  ENTRY_EIGHT_INSTALLMENTS = '8_PARCELAS_DE_R$_450',
  ENTRY_TEN_INSTALLMENTS = '10_PARCELAS_DE_R$_360',
  ENTRY_TWELVE_INSTALLMENTS = '12_PARCELAS_DE_R$_300',
}
